<template>
  <el-container class="ebook-container" style="width: 100%">
    <el-aside class="ebook-aside"> </el-aside>
    <el-main
      style="padding: 0; width: 800px; overflow: hidden"
      v-loading="loading"
      element-loading-background="rgba(255, 255, 255, 1)"
      element-loading-text="读取中...."
    >
      <div class="ebook-main" ref="ebookMain">
        <h3 class="title" v-if="ebookInfo.name">
          《{{ `${ebookInfo.name}` }}》
        </h3>
        <!-- 电子书正文 -->
        <!-- <div class="ebook-main-content"
          v-html="bookHtml"
          ref="ebookContent"
          id="ebookContent"
          @mouseup="handleContentMouseUp"
        @click="handleImageClick"></div>-->
        <!-- <tr> -->
        <transition name="slide-fade">
          <viewer :trigger="bookHtml" style="height: 100%; overflow: visible">
            <div
              v-if="doubleLook"
              style="height: 100%; width: 100%; position: relative"
            >
              <div id="doubleLook" ref="doubleLook">
                <div
                  v-html="bookHtml"
                  id="doublePage1"
                  :class="[
                    'ebook-main-content',
                    'ebook-main-content-supplement',
                  ]"
                  ref="doublePage1"
                ></div>
                <div
                  :class="[
                    'ebook-main-content',
                    'ebook-main-content-supplement',
                  ]"
                  ref="doublePage2"
                  id="doublePage2"
                ></div>
              </div>
              <div class="flipbook-viewport" ref="flipbook-viewport">
                <div class="container">
                  <div class="flipbook">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              :class="['ebook-main-content', 'ebook-main-content-supplement']"
              v-html="bookHtml"
              ref="ebookContent"
              id="ebookContent"
            ></div>
          </viewer>
        </transition>
        <!-- 权限相关 -->
        <!-- <div class="auth-part" v-if="showPermission"> -->
        <!-- 电子书目录 -->
        <div class="catalogue" ref="catalogue">
          <v-catalogue
            :content="catalogueContent"
            :list="catalogueList"
            @closeCat="handleCloseDynamicMask('catalogue')"
            @chapterChange="handleChapterChange"
          />
        </div>
        <!-- 电子书设置 -->
        <div class="setting" ref="setting">
          <v-setting @settingCallback="handleSettingCallback"></v-setting>
        </div>
      </div>
    </el-main>
    <el-aside class="ebook-aside">
      <ul class="ebook-opt">
        <li
          v-for="(item, index) in ebookOpt"
          :key="index"
          :class="[
            `opt-icon ${item.iClass}`,
            { active: checkActiveByPanelOpen(item) },
          ]"
          @click="handleClick(item)"
          :ref="item.ref"
        >
          <i></i>
        </li>
      </ul>
      <ul class="ebook-opt ebook-paging-opt">
        <li
          :class="['prev', { disabled: !havePrev }]"
          @click="handlePageChange('prev')"
        >
          <i class="el-icon-arrow-left"></i>
        </li>
        <li
          :class="['next', { disabled: !haveNext }]"
          @click="handlePageChange('next')"
        >
          <i class="el-icon-arrow-right"></i>
        </li>
      </ul>
    </el-aside>
    <!-- 登录弹窗 -->

    <!-- 开通vip 弹窗 -->
    <!-- 纠错 -->

    <!-- 图片查看大图 -->
    <el-dialog
      title
      class="artical-img-modal"
      :visible.sync="imgInArticalVisible"
    >
      <div class="artical-img-wraper">
        <img :src="imgSrc" />
      </div>
    </el-dialog>
    <!-- 收藏msg -->
  </el-container>
</template>
<script>
import _ from "lodash";
import { RESOURCETYPE_CODE, WEBSITE_BASEURL } from "../utils/global";
import { getBookInfo, getEBookContent } from "../api/resource";
import { errorMessage, modifySuccess, warningMessage } from "../utils/tip";
import { arr2tree, tree2Arr } from "../utils/arr";
import { loadCss } from "../utils";

import EbookCatalogue from "./components/catalogue";
import EbookSetting from "./components/setting";
import { Message } from "element-ui";
import turn from "./lib/turn";
import "./lib/jquery.nicescroll.min";

export default {
  name: "zr-Ebook",
  props:{
    preEbookId:{
      type:String,
      default:''
    },
    preMid:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      show: false,
      doubleLook: false,
      doubleDom: [],
      currentDoubleDom: "",
      time50: [],
      website: WEBSITE_BASEURL,
      ebookId: "", // 图书ID
      markId: "", // 章节ID
      orderNum: "", // 排序号
      orderNum2: "",
      orderMaxNum: "", // 最大目录排序
      orderMinNum: "", // 最小目录排序
      doubleNum: 0,
      ebookInfo: {}, //除去vue警告
      isCollection: 0, // 0：未收藏；1：已收藏
      activeCatId: RESOURCETYPE_CODE.rsWenku,
      ebookOpt: [
        {
          type: "home",
          iClass: "home",
        },
        {
          type: "catalogue",
          iClass: "catalogue",
          ref: "opt-catalogue",
        },
        {
          type: "setting",
          iClass: "setting",
          ref: "opt-setting",
        },
        {
          type: "danye",
          iClass: "danye",
        },
      ],

      catalogueContent: "电子书目录",
      catalogueList: [],
      catPermissionType: "first", // whole-整章章节 first-第一章第一节等
      ids: [],
      flattenCatalogueList: [],
      noteSide: "笔记",
      correctVisble: false,

      messageCode: "",
      message: "",

      bookHtml: "",
      loading: false,
      // 添加笔记相关
      buttonStyle: {
        display: "none",
        left: 0,
        top: 0,
      },
      scrollTopMy: 0,
      selectedText: "",
      noteInpText: "",
      noteInputLen: 0,
      articleId: "",
      highlighter: null,
      noteSources: null,
      noteFleg: true,
      NoteList: [],
      upDateId: "",
      imgSrc: "",
      imgInArticalVisible: false,

      buyVipVisible: false,

      collectLoading: false, // 避免重复点收藏

      showPermission: false,

      catalogueIsOpen: false,
      settingIsOpen: false,

      collectTxt: "收藏成功",
      timer: null,
    };
  },
  components: {
    "v-catalogue": EbookCatalogue,
    "v-setting": EbookSetting,
  },
  computed: {
    // 是否有上一页
    havePrev() {
      return (
        parseInt(this.orderNum, 10) <= parseInt(this.orderMaxNum, 10) &&
        parseInt(this.orderNum, 10) > parseInt(this.orderMinNum, 10)
      );
    },
    // 是否有下一页
    haveNext() {
      return !(parseInt(this.orderNum, 10) >= parseInt(this.orderMaxNum, 10));
    },
  },
  watch: {},
  methods: {
    handleCloseDynamicMask(refStr) {
      if (this.$refs[refStr].classList.contains("transition")) {
        this.$refs[refStr].classList.remove("transition");
        refStr === "catalogue" && (this.catalogueIsOpen = false);
        refStr === "setting" && (this.settingIsOpen = false);
      } else {
        ["catalogue", "setting"].forEach((item) =>
          this.$refs[item].classList.remove("transition")
        );
        this.$refs[refStr].classList.add("transition");
        refStr === "catalogue" && (this.catalogueIsOpen = true);
        refStr === "setting" && (this.settingIsOpen = true);
      }
      //qll加的清除笔记按钮和弹框用的
      this.buttonStyle.display = "none";
    },
    checkActiveByPanelOpen(record) {
      // 先把目录和设置的高亮去掉
      this.$refs["opt-catalogue"] &&
        this.$refs["opt-catalogue"][0].classList.contains("active") &&
        this.$refs["opt-catalogue"][0].classList.remove("active");
      this.$refs["opt-setting"] &&
        this.$refs["opt-setting"][0].classList.contains("active") &&
        this.$refs["opt-setting"][0].classList.remove("active");
      const type = record.type;
      let boole = false;
      switch (type) {
        case "catalogue":
          boole = this.catalogueIsOpen;
          break;
        case "setting":
          boole = this.settingIsOpen;
          break;
        case "collect":
          boole = this.isCollection === 1;
          break;
        default:
          break;
      }
      return boole;
    },
    handleClick(record) {
      const type = record.type;
      let me = this;
      switch (type) {
        case "home":
          this.$router.push({ name: "Home" });
          break;
        case "catalogue":
          this.handleCloseDynamicMask("catalogue");
          break;
        case "setting":
          this.handleCloseDynamicMask("setting");
          break;
        case "danye":
          if (this.doubleLook) {
            //切换单页
            this.doubleLook = false;
            let currrntPage = $(".flipbook").turn("page");
            me.orderNum2 = $(`[page=${currrntPage + 1}]`)
              .find(".ebook-main-content")
              .attr("ordernum");
            console.log(me.orderNum2);
            me.getEbookContent(me.markid, me.orderNum2);
            this.$nextTick(() => {
              $("#ebookContent").niceScroll({
                cursorcolor: "#6A7075",
              });
            });
          } else {
            //切换双页
            $("#ebookContent").getNiceScroll().remove();
            $("#ebookContent").removeAttr("style");
            this.doubleLook = true;
            this.$nextTick(() => {
              me.doubleDom = [];
              let doublePage = this.$refs["flipbook-viewport"];
              let doublePageheight = doublePage.offsetHeight;
              let doublePagewidth = doublePage.offsetWidth;
              $(".flipbook").turn({
                width: doublePagewidth + 40,
                // Height
                height: doublePageheight + 60,
                // Elevation
                elevation: 0,
                // Enable gradients
                gradients: true,
                // Auto center this flipbook
                // autoCenter: true,
                page: 1,
                acceleration: true,
              });
              $(".flipbook").bind("last", function (event) {
                let flipbookpage = $(".flipbook").turn("pages");
                if (flipbookpage > 6) {
                  me.$nextTick(() => {
                    me.doubleDom = [];
                    me.computedDouble();
                  });
                }
              });
              let flipbooklength = $(".flipbook").turn("pages");
              if (flipbooklength > 1) {
                for (let i = 2; i <= flipbooklength; i++) {
                  $(".flipbook").turn("removePage", 2);
                }
              }
              me.getEbookContent(me.markid, me.orderNum2);
            });
          }
          break;
        default:
          break;
      }
    },
    // 电子书设置回调
    handleSettingCallback(callbackPrams) {
      const { close, data } = callbackPrams;
      if (close) {
        this.handleCloseDynamicMask("setting");
      }
      if (this.doubleLook) {
        this.callDoubleOrOne("doublePage1", data, close);
        // this.callDoubleOrOne("doublePage2", data, close);
        this.callDoubleOrOne("flipbook-viewport", data, close);
      } else {
        this.callDoubleOrOne("ebookContent", data, close);
      }

      // 主题
      Array.from(this.$refs["ebookMain"].classList).forEach((classItem) => {
        this.$refs["ebookMain"].classList.remove(classItem);
      });
      this.$refs["ebookMain"].classList.add("ebook-main");
      if (data.topic) {
        this.$refs["ebookMain"].classList.add(`topic-${data.topic}`);
      }
      $("#ebookContent").niceScroll({
        cursorcolor: "#6A7075",
      });
      if (this.doubleLook) {
        this.doubleDom = [];
        let flipbooklength = $(".flipbook").turn("pages");
        // console.log(flipbooklength);
        for (let i = 2; i <= flipbooklength; i++) {
          $(".flipbook").turn("removePage", 2);
        }
      }
      // this.$refs["doublePage"].innerHTML = '';
      this.getEbookContent(this.markId, this.orderNum2);
    },
    callDoubleOrOne(Content, data, close) {
      Array.from(this.$refs[Content].classList).forEach((classItem) => {
        this.$refs[Content].classList.remove(classItem);
      });
      if (Content == "doublePage1" || Content == "ebookContent") {
        this.$refs[Content].classList.add("ebook-main-content");
      }
      if (this.doubleLook) {
        this.$refs[Content].style.overflow = "visible";
        //  this.$refs[Content].style.position = 'static';
      }
      if (!data) {
        return;
      }
      // 字体
      if (data.fontFamily) {
        this.$refs[Content].classList.add(`fontfamily-${data.fontFamily}`);
      }
      // 字体大小
      if (data.fontSize) {
        this.$refs[Content].classList.add(`fontsize-${data.fontSize}`);
      }
      // 行间距
      if (data.lineHeight) {
        this.$refs[Content].classList.add(`lineHeight-${data.lineHeight}`);
      }
    },

    // 点击目录回调
    handleChapterChange(callbackPrams) {
      let me = this;
      const { close, data } = callbackPrams;
      if (close) {
        this.handleCloseDynamicMask("catalogue");
      }
      if (data) {
        const { bookid, markid, orderNum } = data;
        this.orderNum = orderNum;
        this.markId = markid;
        this.ebookId = bookid;
        if (me.doubleLook) {
          me.doubleDom = [];
          let flipbooklength = $(".flipbook").turn("pages");
          // console.log(flipbooklength);
          for (let i = 2; i <= flipbooklength; i++) {
            $(".flipbook").turn("removePage", 2);
          }
        }
        this.getEbookContent(markid, orderNum);
      }
    },

    getBookInfo(bId) {
      getBookInfo( bId || this.ebookId ).then((result) => {
          // console.log("书籍信息", result);
          document.title = result.name || "电子书阅读";
          const {
            epubFile,
            xmlFile,
            pdfFile,
            messageCode,
            message,
            isCollection,
            cssPath,
          } = result;
          this.ebookInfo = result;
          this.isCollection = isCollection;

          // 权限相关
          this.messageCode = messageCode;
          this.message = message;

          // 目录
          this.catalogueContent = result.bookCatalog;
          this.catalogueList = this.dealCatalogue(result.chapterList);
          if ( this.preMid) {
            this.markId = this.preMid;
            this.getEbookContent(this.markId);
          }

          // 加载css
          if (cssPath) {
            const _cssPath = `${this.website}${cssPath
              .split("\\")
              .join("/")}/stylesheet.css`;
            loadCss(_cssPath);
          }
        });
    },

    /************************ 添加笔记相关 start ************************/

    /************************ 添加笔记相关 end ************************/
    // 获取电子书内容
    getEbookContent(mId, oNum, type) {
      // this.show = false
      const self = this;
      const params = {
        bookId: this.ebookId,
      };
      mId && (params["markId"] = mId);
      oNum && (params["orderNum"] = oNum);
      getEBookContent({ ...params }).then((result) => {
        let {
          orderMinNum,
          orderMaxNum,
          orderNum,
          text,
          id,
          innerText,
        } = result;
        this.doubleNum += 1;
        let str = "/sc/9787509214701";
        let reg = new RegExp(str, "g");
        text = text.replace(reg, "http://zgsccbs.com/sc/9787509214701").replace(/\..\//g,'');
        self.bookHtml =
          text + `<nono style='display:none'>${this.doubleNum}</nono>`;
        //  console.log('正文',text);
        // this.show = true
        let that = self;
        this.articleId = id;
        this.orderMinNum = orderMinNum;
        this.orderMaxNum = orderMaxNum;
        this.orderNum = orderNum;
        this.orderNum2 = orderNum;
        //计算单页内容高度
        let Height600 = false;
        this.$nextTick(() => {
          if (!self.doubleLook) {
            //document.getElementById('ebookContent').scrollIntoView(true);
            document.getElementById("ebookContent").scrollTop = 0;
            // self.$refs['ebookContent'].scrollIntoView(true);
            let DlH = 0;
            let childL = self.$refs["ebookContent"].children.length;
            for (let i = 0; i < childL; i++) {
              DlH += self.$refs["ebookContent"].children[i].offsetHeight;
            }
            if (DlH < 600 && self.orderNum != 0) {
              self.AutogetEbookContent();
            }
          }
        });

        // if (innerText.length < 500 && this.doubleLook == false) {
        //     that.orderMinNum = orderMinNum;
        //     that.orderMaxNum = orderMaxNum;
        //     that.orderNum = orderNum;
        //     that.AutogetEbookContent();
        //     // that.handlePageChange("next");
        // }

        // this.$forceUpdate();
        if (self.doubleLook) {
          this.$nextTick(() => {
            this.computedDouble();
          });
        }
      });
    },
    // 上一页、下一页
    handlePageChange(type) {
      let me = this;
      const { orderMinNum, orderMaxNum, havePrev, haveNext } = this;
      let { orderNum, orderNum2 } = this;

      // console.log(haveNext, orderNum, 4444);
      if ((type === "prev" && !havePrev) || (type === "next" && !haveNext)) {
        return;
      }

      // 判断是否有阅读权限
      // console.log(!this.hasPermission(type, orderNum), 6666);

      // if (!this.hasPermission(type, orderNum)) {
      //   warningMessage("暂无阅读权限", 2);
      //   return;
      // }
      if (this.doubleLook) {
        //双页
        if (type === "prev") {
          //  orderNum--;
          //  this.getEbookContent(null, this.orderNum2-1, type);
          if (
            $(".flipbook").turn("page") == 2 ||
            $(".flipbook").turn("page") == 3
          ) {
            me.doubleDom = [];
            let flipbooklength = $(".flipbook").turn("pages");
            // console.log(flipbooklength);
            for (let i = 2; i <= flipbooklength; i++) {
              $(".flipbook").turn("removePage", 2);
            }
            let num = this.orderNum2 == 0 ? 0 : this.orderNum2 - 1;
            this.getEbookContent(this.markid, num);
          } else {
            $(".flipbook").turn("previous");
          }
        }
        if (type === "next") {
          // orderNum++;
          // this.getEbookContent(null, orderNum, type);
          $(".flipbook").turn("next");
        }
      } else {
        if (type === "prev") {
          orderNum2--;
          this.getEbookContent(null, orderNum2, type);
        }
        if (type === "next") {
          orderNum++;
          this.getEbookContent(null, orderNum, type);
        }
      }
      // this.show = false
    },
    AutogetEbookContent() {
      const self = this;
      let { orderNum } = this;
      const params = {
        bookId: this.ebookId,
      };
      params["orderNum"] = orderNum + 1;
      this.orderNum += 1;

      //this.loading = false;
      // if(this.doubleLook && $(".flipbook").turn("page") == 6){
      //    warningMessage("内容不足，双页不可用", 2);
      //     this.doubleLook = false;
      //     let currrntPage = $(".flipbook").turn("page");
      //     let currentNum = $(`[page=${currrntPage + 1}]`)
      //       .find(".ebook-main-content")
      //       .attr("ordernum");
      //     currentNum?self.orderNum2=currentNum:self.orderNum2=this.orderNum-1;
      //     self.getEbookContent(self.markid, self.orderNum2);
      //     this.$nextTick(() => {
      //       $("#ebookContent").niceScroll({
      //         cursorcolor: "#6A7075"
      //       });
      //     });
      //     return;
      // }
      // if(this.doubleLook&&self.doubleDom.length<=6){
      //   console.log('AutogetEbookContent <=6');
      //   self.doubleDom.forEach(i => {
      //   let orderNum = i.getAttribute("ordernum");
      //   $(".flipbook").turn("addPage", i, "", orderNum);

      //    });
      //   this.loading = false;
      // }
      // return;
      getEBookContent({ ...params }).then(
        (result) => {
          let {
            orderMinNum,
            orderMaxNum,
            orderNum,
            text,
            id,
            innerText,
          } = result;
          let str = "/sc/9787509214701";
          let reg = new RegExp(str, "g");
          text = text.replace(reg, "http://zgsccbs.com/sc/9787509214701");
          //this.bookHtml = this.bookHtml+"<div style='height:2px;margin-top:0;margin-bottom:0;width:100%'><HR align='center' color=#987cb9 SIZE=1 style='width:100%'></div>"+text;
          this.bookHtml = this.bookHtml + text;
          // console.log(this.bookHtml);
          // this.show = true
          let that = this;
          this.orderNum = orderNum;
          this.orderMaxNum = orderMaxNum;
          // this.$forceUpdate();
          if (this.doubleLook) {
            self.$nextTick(() => {
              this.computedDouble();
            });
          } else {
            // let innerText = self.$refs['ebookContent'].innerText;
            //  if (innerText.length < 500 ) {
            //   self.orderMinNum = orderMinNum;
            //   self.orderMaxNum = orderMaxNum;
            //   self.orderNum = orderNum;
            //   that.AutogetEbookContent();
            //   // that.handlePageChange("next");
            //  }
            this.$nextTick(() => {
              let DlH = 0;
              let childL = self.$refs["ebookContent"].children.length;
              for (let i = 0; i < childL; i++) {
                DlH += self.$refs["ebookContent"].children[i].offsetHeight;
              }
              if (DlH < 600) {
                that.AutogetEbookContent();
              }
            });
          }
        },
        (err) => {
          this.orderNum--;
        }
      );
    },
    hasPermission(type, orderNum) {
      //console.log(this, type, orderNum, "bbbb");
      let _orderNum = orderNum;
      type === "prev" && _orderNum--;
      type === "next" && _orderNum++;
      // const { catalogueList } = this
      // console.log(this.catalogueList, "cccc");
      const recordItem = this.getItemByOrderNum(this.catalogueList, _orderNum);
      //console.log(recordItem, "aaaa"); //自动触发打印undefined
      return recordItem && recordItem.hasPermission;
    },
    getItemByOrderNum(list, orderNum) {
      return _.find(
        this.flattenCatalogueList,
        (item) => item.orderNum === orderNum
      );
    },
    // 处理目录结构
    dealCatalogue(list) {
      list.forEach((listItem) => (listItem["hasPermission"] = true)); // 默认都具备阅读权限
      const result = arr2tree(list, {
        id: "markid",
        key: "markid",
        parent_id: "pid",
        chapterName: "chapterName",
        pid: "pid",
        bookid: "bookid",
        bookName: "bookName",
        orderNum: "orderNum",
        markid: "markid",
        level: "level",
        hasPermission: "hasPermission",
      });
      // 根据messageCode处理目录的权限-无权限下只有第一章能点击
      const { messageCode, catPermissionType } = this;
      // console.log('目录',JSON.stringify(result))
      this.ids = [];
      // if (!_.isNull(messageCode)) {
      //   // 无权限
      //   catPermissionType === "first" &&
      //     this.getPremissionIdsFirst(_.cloneDeep(result));
      //   catPermissionType === "whole" &&
      //     this.getPremissionIdsWhole(_.cloneDeep(result[0]));
      //   this.setPermission(result, this.ids);
      // }
      this.flattenCatalogueList = tree2Arr(_.cloneDeep(result));
      return result;
    },
    // 递归查找第一个章节的id，以及其所属上级id
    getPremissionIdsFirst(catList) {
      if (_.isArray(catList) && _.isArray(catList[0].children)) {
        this.ids.push(catList[0].id); // 记录level1
        this.getPremissionIdsFirst(catList[0].children[0]);
      } else if (_.isArray(catList.children)) {
        this.ids.push(catList.id); // 记录level2
        this.getPremissionIdsFirst(catList.children[0]);
      } else {
        this.ids.push(catList.id);
      }
    },
    // 设置整一章的章节
    getPremissionIdsWhole(catList) {
      if (_.isArray(catList)) {
        catList.forEach((item) => {
          this.ids.push(item.id);
          _.isArray(item.children) && this.getPremissionIdsWhole(item.children);
        });
      } else {
        this.ids.push(catList.id);
        _.isArray(catList.children) &&
          this.getPremissionIdsWhole(catList.children);
      }
    },
    // 给目录数据结构设置hasPermission标记
    setPermission(list) {
      const ids = this.ids;
      list.forEach((item) => {
        if (ids.includes(item.id)) {
          item["hasPermission"] = true;
        } else {
          item["hasPermission"] = false;
        }
        item.children && this.setPermission(item.children);
      });
    },
    // 文中正文图片点击放大
    handleImageClick(event) {
      const target = event.target || event.srcElement;
      if (
        target.nodeName.toLocaleLowerCase() === "img" ||
        target.tagName.toLocaleLowerCase() === "img"
      ) {
        this.imgSrc = target.src;
        this.imgInArticalVisible = true;
      }
    },

    // 有滚动条监测滚动事件
    handleScroll() {
      const element =
        document.getElementById("ebookContent") || this.$refs["ebookContent"];
      const scrollTop = element.scrollTop; //变量 windowHeight 是可视区的高度
      const windowHeight = element.clientHeight; //变量 scrollHeight 是滚动条的总高度
      const scrollHeight = element.scrollHeight;
      if (scrollTop + windowHeight == scrollHeight) {
        console.log("到底了");
      }
      if (scrollTop === 0) {
        console.log("到头了");
      }
    },

    handleMousewheel: _.throttle(function (event) {
      //滚动的时候隐藏弹框和按钮
      this.buttonStyle.display = "none";
      let direct = 0;
      const ev = event || window.event;
      ev.stopPropagation();
      if (ev.wheelDelta) {
        // 判断浏览器IE，谷歌滑轮事件
        if (ev.wheelDelta > 0) {
          // console.log('滑轮向上滚动');
          this.goUp(ev);
        }
        if (ev.wheelDelta < 0) {
          // console.log('滑轮向下滚动');
          this.goDown(ev);
        }
      } else if (ev.detail) {
        //Firefox滑轮事件
        if (ev.detail > 0) {
          // console.log('滑轮向上滚动');
          this.goUp(ev);
        }
        if (ev.detail < 0) {
          // console.log('滑轮向下滚动');
          this.goDown(ev);
        }
      }
    }, 2000),

    mouseWheelPosition(direct) {
      const element =
        document.getElementById("ebookContent") || this.$refs["ebookContent"];
      if (!element) {
        return { isTop: false, isBottom: false };
      }
      const scrollTop = element.scrollTop; //变量 windowHeight 是可视区的高度
      const windowHeight = element.clientHeight; //变量 scrollHeight 是滚动条的总高度
      const scrollHeight = element.scrollHeight;
      this.scrollTopMy = scrollTop;
      if (direct === "down") {
        // 下滑
        if (scrollTop + windowHeight == scrollHeight) {
          // console.log('到底了');
          return { isTop: false, isBottom: true };
        }
      } else {
        // 上滑
        if (scrollTop === 0) {
          // console.log('到头了');
          return { isTop: true, isBottom: false };
        }
      }
      return { isTop: false, isBottom: false };
    },
    goUp(e) {
      if (this.mouseWheelPosition("up").isTop) {
        this.handlePageChange("prev");
        return;
      }
    },
    goDown(e) {
      if (this.mouseWheelPosition("down").isBottom) {
        this.handlePageChange("next");
        return;
      }
    },
    computedDouble(num) {
      this.loading = true;
      let me = this;
      let doublePage = this.$refs["doublePage1"];
      let doublePagechild = doublePage.children;
      let doublePageheight = doublePage.offsetHeight - 60;
      let doublePagewidth = doublePage.offsetWidth - 40;
      let pFontsize;
      let doublePagelineHeight = window
        .getComputedStyle(doublePage)
        .lineHeight.replace("px", "");
      for (let i = 0; i < doublePage.children.length; i++) {
        if (pFontsize) {
          break;
        }
        pFontsize = window
          .getComputedStyle(doublePage.children[i])
          .fontSize.replace("px", "");
      }
      let marginNum = 0;
      doublePageheight = Number(doublePageheight);
      let Allhang = Math.floor(
        Number(doublePageheight) / Number(doublePagelineHeight)
      );
      let singleZi = Number(doublePagewidth) / Number(pFontsize);
      let shouldZi = Number(Allhang) * Number(singleZi);
      let hangNum = 0;
      me.singleZi = singleZi;
      let currentP, miunsHang, currentindex, phang;
      for (let i = 0; i < doublePagechild.length; i++) {
        let marginTop = window
          .getComputedStyle(doublePagechild[i])
          .marginTop.replace("px", "");
        let marginBottom = window
          .getComputedStyle(doublePagechild[i])
          .marginBottom.replace("px", "");
        phang =
          Number(doublePagechild[i].offsetHeight) +
          Number(marginTop) +
          Number(marginBottom);
        hangNum = hangNum + phang;
        if (hangNum > doublePageheight) {
          miunsHang = hangNum - Allhang;
          currentP = doublePagechild[i];
          currentindex = i;
          break;
        }
        if (hangNum == doublePageheight) {
          miunsHang = 0;
          currentP = doublePagechild[i];
          currentindex = i;
          break;
        }
      }

      if (hangNum < doublePageheight) {
        console.log(me.orderMaxNum,me.orderNum);
        if (me.doubleDom.length < 6 && me.orderMaxNum > me.orderNum) {
          this.AutogetEbookContent();
          return;
        } 
        if(me.orderMaxNum <= me.orderNum){
          this.loading = false;
          warningMessage("内容不足，双页不可用", 2);
          this.doubleLook = false;
          let currrntPage = $(".flipbook").turn("page");
          let currentNum = $(`[page=${currrntPage + 1}]`)
            .find(".ebook-main-content")
            .attr("ordernum");
          currentNum
            ? (self.orderNum2 = currentNum)
            : (self.orderNum2 = this.orderNum - 1);
          this.getEbookContent(self.markid, self.orderNum2);
          this.$nextTick(() => {
            $("#ebookContent").niceScroll({
              cursorcolor: "#6A7075",
            });
          });
          return;
        }
      }
      if (me.doubleDom.length >= 6) {
        me.doubleDom.forEach((i) => {
          let orderNum = i.getAttribute("ordernum");
          $(".flipbook").turn("addPage", i, "", orderNum);
          if ($(".flipbook").turn("pages") == 7) {
            $(".flipbook").turn("page", 2);
          }
          this.loading = false;
        });
      }
      if (currentP && hangNum >= doublePageheight) {
        if (
          currentP.className == "picture_table" ||
          currentP.className == "picture_figure"
        ) {
          let imgreallyH;
          let imgheight = currentP.offsetHeight - (hangNum - doublePageheight);
          // console.log(imgheight);
          let chazhi = imgheight - doublePageheight / 7;
          for (let i = 0; i < currentP.children.length; i++) {
            if (currentP.children[i].tagName == "IMG") {
              console.log(
                "检测到图片",
                imgheight,
                hangNum - doublePageheight,
                currentP.offsetHeight
              );
              imgreallyH = currentP.children[i].offsetHeight;
              if (chazhi >= 0) {
                currentP.children[i].style.height = imgheight + "px";
              }
            }
          }
          if (imgheight <= 0 || chazhi < 0) {
            //保存临界点之后的元素
            let newDiv = document.createElement("div");
            for (let i = 0; i < doublePagechild.length; i++) {
              if (i >= currentindex) {
                newDiv.appendChild(doublePagechild[i].cloneNode(true));
              }
            }
            //删除临界点之前的元素
            for (let i = doublePagechild.length - 1; i > 0; i--) {
              if (i < currentindex) {
                break;
              }
              doublePage.removeChild(doublePagechild[i]);
            }
            doublePage.setAttribute("ordernum", me.orderNum);
            me.doubleDom.push(doublePage.cloneNode(true));
            doublePage.innerHTML = "";
            me.bookHtml = newDiv.innerHTML;
            me.currentDoubleDom = doublePage.innerHTML;
            if (me.doubleDom.length > 6) {
              return;
            }
            me.$nextTick(() => {
              me.computedDouble();
            });
            return;
          }
          //保存临界点之后的元素
          let newDiv = document.createElement("div");
          for (let i = 0; i < doublePagechild.length; i++) {
            if (i > currentindex) {
              newDiv.appendChild(doublePagechild[i].cloneNode(true));
            }
          }
          //删除临界点之前的元素
          for (let i = doublePagechild.length - 1; i > 0; i--) {
            if (i <= currentindex) {
              break;
            }
            doublePage.removeChild(doublePagechild[i]);
          }
          doublePage.setAttribute("ordernum", me.orderNum);
          me.doubleDom.push(doublePage.cloneNode(true));
          doublePage.innerHTML = "";
          me.bookHtml = newDiv.innerHTML;
          me.currentDoubleDom = doublePage.innerHTML;
          if (me.doubleDom.length > 6) {
            return;
          }
          me.$nextTick(() => {
            me.computedDouble();
          });
          return;
        }
        let currentPhang = currentP.offsetHeight / doublePagelineHeight;
        let ShouldHeight =
          currentP.offsetHeight + 16 - (hangNum - doublePageheight);
        //这里先暂时减少一行 要不翻页效果不好展示
        let shouldHang = Math.round(ShouldHeight / doublePagelineHeight) - 1;
        if (shouldHang < 0) {
          shouldHang = 0;
        }
        let currentZi = Math.round(shouldHang * singleZi) - 4;
        let strzi = doublePagechild[currentindex].innerText;
        let afterStr = strzi.substring(0, currentZi);
        let beforeStr = strzi.substring(currentZi, strzi.length);
        let newdom = doublePagechild[currentindex].cloneNode(true);
        let newdom2 = doublePagechild[currentindex].cloneNode(true);
        // let NewdoublePagechild = doublePage.cloneNode(true);
        newdom.innerHTML = afterStr;
        newdom2.innerHTML = beforeStr;
        //保存临界点之后的元素
        var reg = /[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/;
        let newDiv = document.createElement("div");
        for (let i = 0; i < doublePagechild.length; i++) {
          if (i > currentindex) {
            newDiv.appendChild(doublePagechild[i].cloneNode(true));
          }
        }
        if (
          newDiv.children.length == 1 &&
          reg.test(newDiv.children[0].innerText)
        ) {
          newDiv.innerHTML = "";
        }
        //删除临界点之后的元素
        for (let i = doublePagechild.length - 1; i > 0; i--) {
          if (i < currentindex) {
            break;
          }
          doublePage.removeChild(doublePagechild[i]);
        }
        doublePage.appendChild(newdom.cloneNode(true));
        doublePage.setAttribute("ordernum", me.orderNum);
        me.doubleDom.push(doublePage.cloneNode(true));
        doublePage.innerHTML = "";
        doublePage.appendChild(newdom2.cloneNode(true));
        for (let i = 0; i < newDiv.children.length; i++) {
          doublePage.appendChild(newDiv.children[i].cloneNode(true));
        }
        // doublePage.appendChild(newDiv);
        me.bookHtml = doublePage.innerHTML;
        me.currentDoubleDom = doublePage.innerHTML;
        if (me.doubleDom.length > 6) {
          return;
        }
        me.$nextTick(() => {
          me.computedDouble();
        });
      }
    },
  },
  created() {
   
      this.ebookId = this.preEbookId;
      this.getBookInfo(); // 图书详情信息
    
  },
  mounted() {
    let me = this;
    this.$nextTick(() => {
      $("#ebookContent").niceScroll({
        cursorcolor: "#6A7075",
      });
    });
    // this.throttleLoad = _.throttle(() => this.handleScroll(), 500);
    // window.addEventListener("scroll", this.throttleLoad, true);
  },
  destroyed() {
    // window.removeEventListener('scroll', this.throttleLoad, true);
    // this.highlighter.dispose();
  },
  updated() {},
};
</script>
<style lang="scss" scoped>
#ebookContent{
  &::-webkit-scrollbar {
    width: 0 !important;
  }
  &::-webkit-scrollbar {
    width: 0 !important;height: 0;
  }
}
</style>
<style>
.slide-fade-enter-active  {
  transition: all .8s ease !important;
}
.slide-fade-leave-active  {
  transition: all .8s cubic-bezier(1,  0.5,  0.8,  1.0) !important;
}
.slide-fade-enter,
 .slide-fade-leave-to {
  transform: translateX(10px) !important;
  opacity: 0 !important;
}
.flipbook-viewport {
  width: 100%;
  height: 100%;
}

.flipbook {
  margin: 0;
  padding: 0;
}
.flipbook .ebook-main-content {
  background-color: #f0f4f6;
}
.flipbook .ebook-main-content img {
  max-width: 100%;
}
.picture_figure,
.picture_table {
  text-align: center;
}
</style>
<style lang="scss" >
#doubleLook {
  display: flex;
  height: 100%;
  width: 100%;
  position: absolute;
  opacity: 0;
  padding: 0;
  margin: 0;
  z-index: -1;
}
#doublePage1,
#doublePage2 {
  flex: 1;
  height: 88%;
  overflow: hidden;
  padding: 30px 20px 0 20px;
  box-sizing: border-box;
}

@import "index";
</style>



// WEBPACK FOOTER //
// src/Epub/Ebook/index.vue